import { LOCALES } from "@jammable/ui-core/src/i18n";
import { LOCALE_HUB_PATHS } from "./localeHubs";

export interface SitemapUrl {
  loc: string;
  priority: number;
  changefreq:
    | "always"
    | "hourly"
    | "daily"
    | "weekly"
    | "monthly"
    | "yearly"
    | "never";
}

export const SITE_URL = "https://www.jammable.com";

export const staticUrls: SitemapUrl[] = [
  { loc: "/", priority: 1.0, changefreq: "daily" },
  // Note: auth-gated / noindexed pages (/settings, /signup, /login, /history)
  // are intentionally NOT listed — submitting them causes GSC "noindex" errors
  // and wastes crawl budget on pages that render empty for anonymous crawlers.
  { loc: "/pricing", priority: 0.9, changefreq: "weekly" },
  { loc: "/terms", priority: 0.5, changefreq: "monthly" },
  { loc: "/shop", priority: 1, changefreq: "monthly" },

  { loc: "/privacy", priority: 0.5, changefreq: "monthly" },
  { loc: "/dmca-policy", priority: 0.5, changefreq: "monthly" },
  { loc: "/refunds", priority: 0.5, changefreq: "monthly" },
  { loc: "/contactus", priority: 0.7, changefreq: "monthly" },
  { loc: "/models", priority: 1.0, changefreq: "hourly" },
  // /custommodels is a permanent 301 redirect to /train — don't submit it
  // (Google flags "Page with redirect"); /train is listed directly below.
  { loc: "/train", priority: 0.9, changefreq: "daily" },

  // Head-term hub/landing pages (see config/hubPages.ts). /ai-cover is a
  // 301 to "/" now; don't list it.
  { loc: "/ai-voice-changer", priority: 0.9, changefreq: "daily" },
  { loc: "/weights-gg-alternative", priority: 0.8, changefreq: "weekly" },

  // Spanish and Portuguese: the landing pages (config/localeHubs.ts) and the
  // translated versions of the core pages (utils/localeSeo.ts LOCALIZED_ROUTES).
  ...LOCALE_HUB_PATHS.map(
    (loc): SitemapUrl => ({ loc, priority: 0.9, changefreq: "weekly" }),
  ),
  ...LOCALES.filter((l) => l !== "en").flatMap((l) =>
    ["", "/models", "/train", "/pricing"].map(
      (p): SitemapUrl => ({
        loc: `/${l}${p}`,
        priority: p ? 0.8 : 1.0,
        changefreq: "daily",
      }),
    ),
  ),

  // Developer landing pages (/docs is a client-rendered reference; these
  // carry the indexable content).
  { loc: "/developers", priority: 0.7, changefreq: "monthly" },
  { loc: "/mcp", priority: 0.6, changefreq: "monthly" },
];

export const modelFilterUrls: SitemapUrl[] = [
  { loc: "/models?filter=music", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=cartoon", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=anime", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=gaming", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=german", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=korean", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=french", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=italian", priority: 0.8, changefreq: "daily" },
  { loc: "/models?filter=public%20figure", priority: 0.8, changefreq: "daily" },
];
